import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { Context } from "../context";
import { UIinput } from "../uikit/UIinput";
import { UIbutton } from "../uikit/Uikit";

const LoginInner = ({ create, forgot, history }) => {
  const context = useContext(Context);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [avatar, setAvatar] = useState("");

  // using Fire.js
  const onPressLogin = async () => {
    // console.log("pressing login... email:" + state.email);
    const user = {
      name,
      email,
      // avatar,
      password,
    };
    // const response = context.handles.login(user, loginSuccess, loginFailed);
  };

  const onPressCreate = async () => {
    console.log("create account... email:" + email);
    // try {
    //   const user = {
    //     name: name,
    //     email: email,
    //     password: password,
    //     avatar: avatar,
    //   };
    //   await context.handles.createAccount(user, loginSuccess, loginFailed);
    // } catch ({ message }) {
    //   console.log('create account failed. catch error:' + message);
    // }
  };

  const onPressForgot = async () => {
    console.log("forgot password for email:" + email);
  };

  const loginSuccess = () => {
    console.log("login successful");
    context.handles.setUserData({
      name,
      email,
      // avatar,
    });
    history.push("/");
  };

  const loginFailed = () => {
    console.log("login failed ***");
    alert("Login failure. Please tried again.");
  };


  //TODO: Handle ENTER
  // const em = useRef()
  // const pw = useRef()
  // useEffect(() => {
  //   const listener = event => {
  //     if (event.code === "Enter" || event.code === "NumpadEnter") {
  //       handle(input.current.value);
  //       onPressLogin()
  //       event.preventDefault();
  //     } else {
  //     }
  //   };
  //   document.addEventListener("keydown", listener);
  //   return () => {
  //     document.removeEventListener("keydown", listener);
  //   };
  // }, []);

  // static navigationOptions = {
  //   title: 'Scv Chatter',
  // };



  return (<>
    <LoginLayout >
      <div className="flex vertical center middle" > {!create && !forgot && (<div className="line line--center" >
        <h1 > Log in to General Symbol </h1> </div>
      )
      } {
          create && (<div className="line line--center" >
            <h1 > Create account </h1> </div>
          )
        }

        {
          forgot && (<div className="line line--center" >
            <h1 > Forgot password </h1> </div>
          )
        }

        <div className="line line--center" >
          <UIinput label="Email"
            onChange={
              (value) => setEmail(value)}
            // placeholder="email@email.com"
            style={
              { width: 300 }}
          /> </div>

        {
          !forgot && (<div className="line line--center" >
            <UIinput password={true}
              label="Password"
              onChange={
                (value) => setPassword(value)}
              // placeholder="******"
              password={true}
              style={
                { width: 300 }}
            /> </div>
          )
        }

        {
          create && (<div className="line line--center" >
            <UIinput label="Username"
              onChange={
                (value) => setName(value)}
              // placeholder="******"
              style={
                { width: 300 }}
            /> </div>
          )
        }

        {
          !create && !forgot && (<>
            <div className="line line--center sm" >
              <UIbutton onClick={onPressLogin} > Log in </UIbutton> </div>

            <div className="line line--center sm" >
              <UIbutton flat sm onClick={
                () => {
                  history.push("/createaccount");
                  // props.navigation.navigate("CreateAccount")
                }
              } >
                Create a free account </UIbutton> </div>

            <div className="line line--center sm" >
              <UIbutton flat sm onClick={
                () => {
                  history.push("/forgotpassword");
                  // props.navigation.navigate("CreateAccount")
                }
              } >
                Forgot password </UIbutton> </div> </>
          )
        }

        {
          create && (<>
            <div className="line line--center sm" >
              <UIbutton onClick={onPressCreate} > Submit </UIbutton> </div>

            <div className="line line--center sm" >
              <UIbutton flat sm onClick={
                () => {
                  history.push("/login");
                  // props.navigation.navigate("CreateAccount")
                }
              } >
                Log in with existing account </UIbutton> </div> </>
          )
        }

        {
          forgot && (<>
            <div className="line line--center sm" >
              <UIbutton onClick={onPressForgot} > Submit </UIbutton> </div>

            <div className="line line--center sm" >
              <UIbutton flat sm onClick={
                () => {
                  history.push("/login");
                  // props.navigation.navigate("CreateAccount")
                }
              } >
                Back to login </UIbutton> </div> </>
          )
        } </div> </LoginLayout> </>
  );
};

export function LoginLayout({ children }) {
  return (<>
    <div className="l_page0" >
      <div className="l_page_top" />
      <div className="l_page_b" > {children} </div> </div> </>
  );
}

export const Login = withRouter(LoginInner);